// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useCallback, useMemo, useEffect} from 'react';
import {OFFERS_SORTING} from '../../utils/constants.js';
import {List} from '../../features/offers';
import {Text} from '../../comp/text';
import {Page} from '../../comp/page';
import store from '../../store.js';
import {OS_FILTERS, SORTING_KEY, OS_KEY, PAGE_SIZE,
    PAGINATION_WINDOW_SIZE} from './constants.js';
import {Filter, Mobile_toggle} from './filter.js';
import {Download_banner} from './download_banner.js';
import * as cns from './offers.module.less';

function Header({filter, on_filter_change, disabled}){
    const [mob_open, set_mob_open] = useState(false);
    return <>
      <div className={cns.title_container}>
        <Text.xxxl h1>Offers</Text.xxxl>
        <Mobile_toggle value={mob_open} on_change={set_mob_open}/>
      </div>
      <Filter className={cns.filter} value={filter} disabled={disabled}
        on_change={on_filter_change} mob_open={mob_open}/>
    </>;
}

export function Offers(){
    const [filter, set_filters] = useState({
        [SORTING_KEY]: OFFERS_SORTING.FAV,
        [OS_KEY]: OS_FILTERS.map(f=>f.id),
    });
    const params = useMemo(()=>({size: PAGE_SIZE, ...filter}), [filter]);
    useEffect(()=>()=>store.use_offers_page.invalidate(), [params]);
    const [data,, loading, pagination] = store.use_offers_page(false, params);
    const handle_filter_change = useCallback((key, value)=>{
        set_filters(v=>({
            ...v,
            [key]: value,
        }));
    }, []);
    return <Page>
      <Header filter={filter} on_filter_change={handle_filter_change}
        disabled={loading}/>
      <Download_banner className={cns.banner}/>
      <List className={cns.list} data={data} pagination={pagination}
        loading={loading} pagination_window_size={PAGINATION_WINDOW_SIZE}/>
    </Page>;
}
